import { render, staticRenderFns } from "./consentCheckbox.vue?vue&type=template&id=6fbbed28"
import script from "./consentCheckbox.vue?vue&type=script&lang=js"
export * from "./consentCheckbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports